function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "white-copy",
  transform: "translate(-933.000000, -231.000000)",
  fill: "#636363",
  fillRule: "nonzero"
}, React.createElement("g", {
  id: "Group-2",
  transform: "translate(933.000000, 231.000000)"
}, React.createElement("g", {
  id: "noun_Arrow_2271217-Copy",
  transform: "translate(4.000000, 7.000000) scale(-1, 1) translate(-4.000000, -7.000000) "
}, React.createElement("g", {
  id: "Group"
}, React.createElement("path", {
  d: "M0.325165882,7.76460656 L5.97221059,13.5023115 C6.4229789,13.9598169 7.16863022,13.9742642 7.63766941,13.5345803 C8.10670861,13.0948965 8.12152008,12.3675809 7.67075176,11.9100754 C7.37023955,11.6050718 5.7501423,9.95787615 2.81046,6.96848852 C5.7501423,3.97909478 7.37023955,2.33189609 7.67075176,2.02689246 C8.12152008,1.56938702 8.10670861,0.84207139 7.63766941,0.402387541 C7.16863022,-0.0372963076 6.4229789,-0.0228490502 5.97221059,0.434656393 L0.325165882,6.17236131 C0.105138903,6.39772518 -0.0116253129,6.70058438 0.00163647059,7.01152131 C0.0111855377,7.29274758 0.126321733,7.56075218 0.325165882,7.76460656 Z",
  id: "Path"
}))))));

const SvgRightArrow = (_ref) => {
  let svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: "8px",
    height: "14px",
    viewBox: "0 0 8 14",
    ref: svgRef
  }, props), _ref2, _ref3);
};

const ForwardRef = React.forwardRef((props, ref) => React.createElement(SvgRightArrow, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/right-arrow.f064c09e.svg";
export { ForwardRef as ReactComponent };